export default {
  AUTHENTICATE: 'AUTHENTICATE',
  CLEAR_USER: 'LOGOUT',
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  SET_CURRENT_USER_AVAILABILITY: 'SET_CURRENT_USER_AVAILABILITY',
  SET_CURRENT_USER_AUTO_OFFLINE: 'SET_CURRENT_USER_AUTO_OFFLINE',
  RESET_ONBOARDING: 'RESET_ONBOARDING',
  SET_CURRENT_USER_UI_SETTINGS: 'SET_CURRENT_USER_UI_SETTINGS',
  SET_CURRENT_USER_UI_FLAGS: 'SET_CURRENT_USER_UI_FLAGS',

  // Chat List
  RECEIVE_CHAT_LIST: 'RECEIVE_CHAT_LIST',
  SET_ALL_CONVERSATION: 'SET_ALL_CONVERSATION',
  EMPTY_ALL_CONVERSATION: 'EMPTY_ALL_CONVERSATION',
  SET_CONV_TAB_META: 'SET_CONV_TAB_META',
  CLEAR_LIST_LOADING_STATUS: 'CLEAR_LIST_LOADING_STATUS',
  SET_LIST_LOADING_STATUS: 'SET_LIST_LOADING_STATUS',
  SET_ALL_MESSAGES_LOADED: 'SET_ALL_MESSAGES_LOADED',
  CLEAR_ALL_MESSAGES_LOADED: 'CLEAR_ALL_MESSAGES_LOADED',
  CHANGE_CHAT_STATUS_FILTER: 'CHANGE_CHAT_STATUS_FILTER',
  CHANGE_CHAT_SORT_FILTER: 'CHANGE_CHAT_SORT_FILTER',
  UPDATE_ASSIGNEE: 'UPDATE_ASSIGNEE',
  UPDATE_CONVERSATION_CONTACT: 'UPDATE_CONVERSATION_CONTACT',
  CLEAR_CONTACT_CONVERSATIONS: 'CLEAR_CONTACT_CONVERSATIONS',
  SET_CONVERSATION_FILTERS: 'SET_CONVERSATION_FILTERS',
  CLEAR_CONVERSATION_FILTERS: 'CLEAR_CONVERSATION_FILTERS',
  SET_CONVERSATION_LAST_SEEN: 'SET_CONVERSATION_LAST_SEEN',
  SET_LAST_MESSAGE_ID_IN_SYNC_CONVERSATION:
    'SET_LAST_MESSAGE_ID_FOR_SYNC_CONVERSATION',
  SET_DRAFT_MESSAGES: 'SET_DRAFT_MESSAGES',
  REMOVE_DRAFT_MESSAGES: 'REMOVE_DRAFT_MESSAGES',
  SET_REPLY_EDITOR_MODE: 'SET_REPLY_EDITOR_MODE',

  SET_CURRENT_CHAT_WINDOW: 'SET_CURRENT_CHAT_WINDOW',
  CLEAR_CURRENT_CHAT_WINDOW: 'CLEAR_CURRENT_CHAT_WINDOW',
  CLEAR_ALL_MESSAGES: 'CLEAR_ALL_MESSAGES',
  CHANGE_CONVERSATION_STATUS: 'CHANGE_CONVERSATION_STATUS',
  ADD_CONVERSATION: 'ADD_CONVERSATION',
  UPDATE_CONVERSATION: 'UPDATE_CONVERSATION',
  MUTE_CONVERSATION: 'MUTE_CONVERSATION',
  UNMUTE_CONVERSATION: 'UNMUTE_CONVERSATION',
  ASSIGN_AGENT: 'ASSIGN_AGENT',
  ASSIGN_TEAM: 'ASSIGN_TEAM',
  ASSIGN_PRIORITY: 'ASSIGN_PRIORITY',
  SET_CHAT_META: 'SET_CHAT_META',
  ADD_MESSAGE: 'ADD_MESSAGE',
  DELETE_MESSAGE: 'DELETE_MESSAGE',
  ADD_PENDING_MESSAGE: 'ADD_PENDING_MESSAGE',
  UPDATE_MESSAGE_UNREAD_COUNT: 'UPDATE_MESSAGE_UNREAD_COUNT',
  SET_PREVIOUS_CONVERSATIONS: 'SET_PREVIOUS_CONVERSATIONS',
  SET_ACTIVE_INBOX: 'SET_ACTIVE_INBOX',
  UPDATE_CONVERSATION_CUSTOM_ATTRIBUTES:
    'UPDATE_CONVERSATION_CUSTOM_ATTRIBUTES',
  UPDATE_CONVERSATION_LAST_ACTIVITY: 'UPDATE_CONVERSATION_LAST_ACTIVITY',
  UPDATE_MESSAGE_CALL_STATUS: 'UPDATE_MESSAGE_CALL_STATUS',
  SET_MISSING_MESSAGES: 'SET_MISSING_MESSAGES',

  SET_ALL_ATTACHMENTS: 'SET_ALL_ATTACHMENTS',
  ADD_CONVERSATION_ATTACHMENTS: 'ADD_CONVERSATION_ATTACHMENTS',
  DELETE_CONVERSATION_ATTACHMENTS: 'DELETE_CONVERSATION_ATTACHMENTS',
  DELETE_CONVERSATION: 'DELETE_CONVERSATION',

  SET_CONVERSATION_CAN_REPLY: 'SET_CONVERSATION_CAN_REPLY',

  SET_CONTEXT_MENU_CHAT_ID: 'SET_CONTEXT_MENU_CHAT_ID',

  SET_CHAT_DATA_FETCHED: 'SET_CHAT_DATA_FETCHED',
  SET_CHAT_LIST_FILTERS: 'SET_CHAT_LIST_FILTERS',
  UPDATE_CHAT_LIST_FILTERS: 'UPDATE_CHAT_LIST_FILTERS',

  // Conversation inbox connected copilot assistant
  SET_INBOX_CAPTAIN_ASSISTANT: 'SET_INBOX_CAPTAIN_ASSISTANT',

  // Inboxes
  SET_INBOXES_UI_FLAG: 'SET_INBOXES_UI_FLAG',
  SET_INBOXES: 'SET_INBOXES',
  SET_INBOX_ITEM: 'SET_INBOX_ITEM',
  ADD_INBOXES: 'ADD_INBOXES',
  EDIT_INBOXES: 'EDIT_INBOXES',
  DELETE_INBOXES: 'DELETE_INBOXES',

  // Agent
  SET_ACCOUNT_UI_FLAG: 'SET_ACCOUNT_UI_FLAG',
  SET_ACCOUNT_LIMITS: 'SET_ACCOUNT_LIMITS',
  SET_ACCOUNTS: 'SET_ACCOUNTS',
  ADD_ACCOUNT: 'ADD_ACCOUNT',
  EDIT_ACCOUNT: 'EDIT_ACCOUNT',
  DELETE_ACCOUNT: 'DELETE_AGENT',

  // Agent
  SET_AGENT_FETCHING_STATUS: 'SET_AGENT_FETCHING_STATUS',
  SET_AGENT_CREATING_STATUS: 'SET_AGENT_CREATING_STATUS',
  SET_AGENT_UPDATING_STATUS: 'SET_AGENT_UPDATING_STATUS',
  SET_AGENT_DELETING_STATUS: 'SET_AGENT_DELETING_STATUS',
  SET_AGENTS: 'SET_AGENTS',
  ADD_AGENT: 'ADD_AGENT',
  EDIT_AGENT: 'EDIT_AGENT',
  DELETE_AGENT: 'DELETE_AGENT',
  UPDATE_AGENTS_PRESENCE: 'UPDATE_AGENTS_PRESENCE',
  UPDATE_SINGLE_AGENT_PRESENCE: 'UPDATE_SINGLE_AGENT_PRESENCE',

  // Canned Response
  SET_CANNED_UI_FLAG: 'SET_CANNED_UI_FLAG',
  SET_CANNED: 'SET_CANNED',
  ADD_CANNED: 'ADD_CANNED',
  EDIT_CANNED: 'EDIT_CANNED',
  DELETE_CANNED: 'DELETE_CANNED',

  // Custom Role
  SET_CUSTOM_ROLE_UI_FLAG: 'SET_CUSTOM_ROLE_UI_FLAG',
  SET_CUSTOM_ROLE: 'SET_CUSTOM_ROLE',
  ADD_CUSTOM_ROLE: 'ADD_CUSTOM_ROLE',
  EDIT_CUSTOM_ROLE: 'EDIT_CUSTOM_ROLE',
  DELETE_CUSTOM_ROLE: 'DELETE_CUSTOM_ROLE',

  // Automation Texts
  SET_AUTOMATION_TEXT_UI_FLAG: 'SET_AUTOMATION_TEXT_UI_FLAG',
  SET_AUTOMATION_TEXTS: 'SET_AUTOMATION_TEXTS',
  ADD_AUTOMATION_TEXT: 'ADD_AUTOMATION_TEXT',
  EDIT_AUTOMATION_TEXT: 'EDIT_AUTOMATION_TEXT',
  DELETE_AUTOMATION_TEXT: 'DELETE_AUTOMATION_TEXT',

  // Labels
  SET_LABEL_UI_FLAG: 'SET_LABEL_UI_FLAG',
  SET_LABELS: 'SET_LABELS',
  ADD_LABEL: 'ADD_LABEL',
  EDIT_LABEL: 'EDIT_LABEL',
  DELETE_LABEL: 'DELETE_LABEL',

  // Phone Central
  SET_PHONE_CENTRAL_UI_FLAG: 'SET_PHONE_CENTRAL_UI_FLAG',
  SET_PHONE_CENTRAL_CONFIGS: 'SET_PHONE_CENTRAL_CONFIGS',
  ADD_PHONE_CENTRAL_CONFIG: 'ADD_PHONE_CENTRAL_CONFIG',
  EDIT_PHONE_CENTRAL_CONFIG: 'EDIT_PHONE_CENTRAL_CONFIG',
  DELETE_PHONE_CENTRAL_CONFIG: 'DELETE_PHONE_CENTRAL_CONFIG',

  // Hotel Rooms
  SET_HOTEL_ROOMS_UI_FLAG: 'SET_HOTEL_ROOMS_UI_FLAG',
  SET_HOTEL_ROOMS: 'SET_HOTEL_ROOMS',
  ADD_HOTEL_ROOM: 'ADD_HOTEL_ROOM',
  EDIT_HOTEL_ROOM: 'EDIT_HOTEL_ROOM',
  DELETE_HOTEL_ROOM: 'DELETE_HOTEL_ROOM',

  // Motor Reserva - Rooms
  SET_MOTOR_RESERVA_ROOMS_UI_FLAG: 'SET_MOTOR_RESERVA_ROOMS_UI_FLAG',
  SET_MOTOR_RESERVA_ROOMS: 'SET_MOTOR_RESERVA_ROOMS',
  ADD_MOTOR_RESERVA_ROOM: 'ADD_MOTOR_RESERVA_ROOM',
  EDIT_MOTOR_RESERVA_ROOM: 'EDIT_MOTOR_RESERVA_ROOM',
  DELETE_MOTOR_RESERVA_ROOM: 'DELETE_MOTOR_RESERVA_ROOM',

  // Motor Reserva - Config
  SET_MOTOR_RESERVA_CONFIG_UI_FLAG: 'SET_MOTOR_RESERVA_CONFIG_UI_FLAG',
  SET_MOTOR_RESERVA_CONFIG: 'SET_MOTOR_RESERVA_CONFIG',

  // Motor Reserva - Rates
  SET_MOTOR_RESERVA_RATES_UI_FLAG: 'SET_MOTOR_RESERVA_RATES_UI_FLAG',
  SET_MOTOR_RESERVA_RATES: 'SET_MOTOR_RESERVA_RATES',
  ADD_MOTOR_RESERVA_RATE: 'ADD_MOTOR_RESERVA_RATE',
  EDIT_MOTOR_RESERVA_RATE: 'EDIT_MOTOR_RESERVA_RATE',
  DELETE_MOTOR_RESERVA_RATE: 'DELETE_MOTOR_RESERVA_RATE',

  // Motor Reserva - Extras
  SET_MOTOR_RESERVA_EXTRAS_UI_FLAG: 'SET_MOTOR_RESERVA_EXTRAS_UI_FLAG',
  SET_MOTOR_RESERVA_EXTRAS: 'SET_MOTOR_RESERVA_EXTRAS',
  ADD_MOTOR_RESERVA_EXTRA: 'ADD_MOTOR_RESERVA_EXTRA',
  EDIT_MOTOR_RESERVA_EXTRA: 'EDIT_MOTOR_RESERVA_EXTRA',
  DELETE_MOTOR_RESERVA_EXTRA: 'DELETE_MOTOR_RESERVA_EXTRA',

  // Motor Reserva - Room Rates
  SET_MOTOR_RESERVA_ROOM_RATES_UI_FLAG: 'SET_MOTOR_RESERVA_ROOM_RATES_UI_FLAG',
  SET_MOTOR_RESERVA_ROOM_RATES: 'SET_MOTOR_RESERVA_ROOM_RATES',
  ADD_MOTOR_RESERVA_ROOM_RATE: 'ADD_MOTOR_RESERVA_ROOM_RATE',
  EDIT_MOTOR_RESERVA_ROOM_RATE: 'EDIT_MOTOR_RESERVA_ROOM_RATE',
  DELETE_MOTOR_RESERVA_ROOM_RATE: 'DELETE_MOTOR_RESERVA_ROOM_RATE',

  // Integrations
  SET_INTEGRATIONS_UI_FLAG: 'SET_INTEGRATIONS_UI_FLAG',
  SET_INTEGRATIONS: 'SET_INTEGRATIONS',
  ADD_INTEGRATION: 'ADD_INTEGRATION',
  DELETE_INTEGRATION: 'DELETE_INTEGRATION',
  ADD_INTEGRATION_HOOKS: 'ADD_INTEGRATION_HOOKS',
  DELETE_INTEGRATION_HOOKS: 'DELETE_INTEGRATION_HOOKS',

  // WebHook
  SET_WEBHOOK_UI_FLAG: 'SET_WEBHOOK_UI_FLAG',
  SET_WEBHOOK: 'SET_WEBHOOK',
  ADD_WEBHOOK: 'ADD_WEBHOOK',
  DELETE_WEBHOOK: 'DELETE_WEBHOOK',
  UPDATE_WEBHOOK: 'UPDATE_WEBHOOK',

  // Contacts
  SET_CONTACT_META: 'SET_CONTACT_META',
  SET_CONTACT_UI_FLAG: 'SET_CONTACT_UI_FLAG',
  SET_CONTACT_ITEM: 'SET_CONTACT_ITEM',
  SET_CONTACT_ATTACHMENTS: 'SET_CONTACT_ATTACHMENTS',
  SET_CONTACTS: 'SET_CONTACTS',
  APPEND_CONTACTS: 'APPEND_CONTACTS',
  CLEAR_CONTACTS: 'CLEAR_CONTACTS',
  EDIT_CONTACT: 'EDIT_CONTACT',
  DELETE_CONTACT: 'DELETE_CONTACT',
  UPDATE_CONTACTS_PRESENCE: 'UPDATE_CONTACTS_PRESENCE',
  SET_CONTACT_FILTERS: 'SET_CONTACT_FILTERS',
  CLEAR_CONTACT_FILTERS: 'CLEAR_CONTACT_FILTERS',

  // Notifications
  SET_NOTIFICATIONS_META: 'SET_NOTIFICATIONS_META',
  SET_NOTIFICATIONS_UNREAD_COUNT: 'SET_NOTIFICATIONS_UNREAD_COUNT',
  SET_NOTIFICATIONS_UI_FLAG: 'SET_NOTIFICATIONS_UI_FLAG',
  UPDATE_NOTIFICATION: 'UPDATE_NOTIFICATION',
  READ_NOTIFICATION: 'READ_NOTIFICATION',
  ADD_NOTIFICATION: 'ADD_NOTIFICATION',
  DELETE_NOTIFICATION: 'DELETE_NOTIFICATION',
  UPDATE_ALL_NOTIFICATIONS: 'UPDATE_ALL_NOTIFICATIONS',
  SET_NOTIFICATIONS_ITEM: 'SET_NOTIFICATIONS_ITEM',
  SET_NOTIFICATIONS: 'SET_NOTIFICATIONS',
  CLEAR_NOTIFICATIONS: 'CLEAR_NOTIFICATIONS',
  EDIT_NOTIFICATIONS: 'EDIT_NOTIFICATIONS',
  UPDATE_NOTIFICATIONS_PRESENCE: 'UPDATE_NOTIFICATIONS_PRESENCE',
  SET_ALL_NOTIFICATIONS_LOADED: 'SET_ALL_NOTIFICATIONS_LOADED',
  DELETE_READ_NOTIFICATIONS: 'DELETE_READ_NOTIFICATIONS',
  DELETE_ALL_NOTIFICATIONS: 'DELETE_ALL_NOTIFICATIONS',
  SNOOZE_NOTIFICATION: 'SNOOZE_NOTIFICATION',
  SET_NOTIFICATION_FILTERS: 'SET_NOTIFICATION_FILTERS',
  UPDATE_NOTIFICATION_FILTERS: 'UPDATE_NOTIFICATION_FILTERS',

  // Contact Conversation
  SET_CONTACT_CONVERSATIONS_UI_FLAG: 'SET_CONTACT_CONVERSATIONS_UI_FLAG',
  SET_CONTACT_CONVERSATIONS: 'SET_CONTACT_CONVERSATIONS',
  ADD_CONTACT_CONVERSATION: 'ADD_CONTACT_CONVERSATION',
  DELETE_CONTACT_CONVERSATION: 'DELETE_CONTACT_CONVERSATION',

  // Contact Label
  SET_CONTACT_LABELS_UI_FLAG: 'SET_CONTACT_LABELS_UI_FLAG',
  SET_CONTACT_LABELS: 'SET_CONTACT_LABELS',

  // Conversation Label
  SET_CONVERSATION_LABELS_UI_FLAG: 'SET_CONVERSATION_LABELS_UI_FLAG',
  SET_CONVERSATION_LABELS: 'SET_CONVERSATION_LABELS',
  SET_BULK_CONVERSATION_LABELS: 'SET_BULK_CONVERSATION_LABELS',
  SET_SELECTED_CONVERSATION_IDS: 'SET_SELECTED_CONVERSATION_IDS',
  CLEAR_SELECTED_CONVERSATION_IDS: 'CLEAR_SELECTED_CONVERSATION_IDS',
  REMOVE_SELECTED_CONVERSATION_IDS: 'REMOVE_SELECTED_CONVERSATION_IDS',

  // Conversation Unread Counts
  SET_CONVERSATION_UNREAD_COUNTS: 'SET_CONVERSATION_UNREAD_COUNTS',

  // Reports
  SET_ACCOUNT_REPORTS: 'SET_ACCOUNT_REPORTS',
  SET_HEATMAP_DATA: 'SET_HEATMAP_DATA',
  TOGGLE_HEATMAP_LOADING: 'TOGGLE_HEATMAP_LOADING',
  SET_RESOLUTION_HEATMAP_DATA: 'SET_RESOLUTION_HEATMAP_DATA',
  TOGGLE_RESOLUTION_HEATMAP_LOADING: 'TOGGLE_RESOLUTION_HEATMAP_LOADING',
  SET_ACCOUNT_SUMMARY: 'SET_ACCOUNT_SUMMARY',
  SET_BOT_SUMMARY: 'SET_BOT_SUMMARY',
  TOGGLE_ACCOUNT_REPORT_LOADING: 'TOGGLE_ACCOUNT_REPORT_LOADING',
  SET_BOT_SUMMARY_STATUS: 'SET_BOT_SUMMARY_STATUS',
  SET_ACCOUNT_SUMMARY_STATUS: 'SET_ACCOUNT_SUMMARY_STATUS',
  SET_ACCOUNT_CONVERSATION_METRIC: 'SET_ACCOUNT_CONVERSATION_METRIC',
  TOGGLE_ACCOUNT_CONVERSATION_METRIC_LOADING:
    'TOGGLE_ACCOUNT_CONVERSATION_METRIC_LOADING',
  SET_AGENT_CONVERSATION_METRIC: 'SET_AGENT_CONVERSATION_METRIC',
  TOGGLE_AGENT_CONVERSATION_METRIC_LOADING:
    'TOGGLE_AGENT_CONVERSATION_METRIC_LOADING',

  // Conversation Metadata
  SET_CONVERSATION_METADATA: 'SET_CONVERSATION_METADATA',

  // Conversation Page
  SET_CURRENT_PAGE: 'SET_CURRENT_PAGE',
  SET_CONVERSATION_END_REACHED: 'SET_CONVERSATION_END_REACHED',
  CLEAR_CONVERSATION_PAGE: 'CLEAR_CONVERSATION_PAGE',

  // Notification Settings
  SET_USER_NOTIFICATION_UI_FLAG: 'SET_USER_NOTIFICATION_UI_FLAG',
  SET_USER_NOTIFICATION: 'SET_USER_NOTIFICATION',

  // User Typing
  ADD_USER_TYPING_TO_CONVERSATION: 'ADD_USER_TYPING_TO_CONVERSATION',
  REMOVE_USER_TYPING_FROM_CONVERSATION: 'REMOVE_USER_TYPING_FROM_CONVERSATION',

  // Conversation Search
  SEARCH_CONVERSATIONS_SET: 'SEARCH_CONVERSATIONS_SET',
  SEARCH_CONVERSATIONS_SET_UI_FLAG: 'SEARCH_CONVERSATIONS_SET_UI_FLAG',

  // Campaigns
  SET_CAMPAIGN_UI_FLAG: 'SET_CAMPAIGN_UI_FLAG',
  SET_CAMPAIGNS: 'SET_CAMPAIGNS',
  ADD_CAMPAIGN: 'ADD_CAMPAIGN',
  EDIT_CAMPAIGN: 'EDIT_CAMPAIGN',
  DELETE_CAMPAIGN: 'DELETE_CAMPAIGN',

  // WhatsApp Campaigns
  SET_WHATSAPP_CAMPAIGN_UI_FLAG: 'SET_WHATSAPP_CAMPAIGN_UI_FLAG',
  SET_WHATSAPP_CAMPAIGNS: 'SET_WHATSAPP_CAMPAIGNS',
  ADD_WHATSAPP_CAMPAIGN: 'ADD_WHATSAPP_CAMPAIGN',
  EDIT_WHATSAPP_CAMPAIGN: 'EDIT_WHATSAPP_CAMPAIGN',
  DELETE_WHATSAPP_CAMPAIGN: 'DELETE_WHATSAPP_CAMPAIGN',

  // Scheduled Notifications
  SET_SCHEDULED_NOTIFICATION_UI_FLAG: 'SET_SCHEDULED_NOTIFICATION_UI_FLAG',
  SET_SCHEDULED_NOTIFICATIONS: 'SET_SCHEDULED_NOTIFICATIONS',
  ADD_SCHEDULED_NOTIFICATION: 'ADD_SCHEDULED_NOTIFICATION',
  EDIT_SCHEDULED_NOTIFICATION: 'EDIT_SCHEDULED_NOTIFICATION',
  DELETE_SCHEDULED_NOTIFICATION: 'DELETE_SCHEDULED_NOTIFICATION',

  // Notification Auto Replies
  SET_NOTIFICATION_AUTO_REPLY_UI_FLAG: 'SET_NOTIFICATION_AUTO_REPLY_UI_FLAG',
  SET_NOTIFICATION_AUTO_REPLIES: 'SET_NOTIFICATION_AUTO_REPLIES',
  ADD_NOTIFICATION_AUTO_REPLY: 'ADD_NOTIFICATION_AUTO_REPLY',
  EDIT_NOTIFICATION_AUTO_REPLY: 'EDIT_NOTIFICATION_AUTO_REPLY',
  DELETE_NOTIFICATION_AUTO_REPLY: 'DELETE_NOTIFICATION_AUTO_REPLY',

  // Notification Email Configs
  SET_NOTIFICATION_EMAIL_CONFIG_UI_FLAG: 'SET_NOTIFICATION_EMAIL_CONFIG_UI_FLAG',
  SET_NOTIFICATION_EMAIL_CONFIGS: 'SET_NOTIFICATION_EMAIL_CONFIGS',
  ADD_NOTIFICATION_EMAIL_CONFIG: 'ADD_NOTIFICATION_EMAIL_CONFIG',
  EDIT_NOTIFICATION_EMAIL_CONFIG: 'EDIT_NOTIFICATION_EMAIL_CONFIG',
  DELETE_NOTIFICATION_EMAIL_CONFIG: 'DELETE_NOTIFICATION_EMAIL_CONFIG',

  // Contact Lists
  SET_CONTACT_LIST_UI_FLAG: 'SET_CONTACT_LIST_UI_FLAG',
  SET_CONTACT_LISTS: 'SET_CONTACT_LISTS',
  ADD_CONTACT_LIST: 'ADD_CONTACT_LIST',
  EDIT_CONTACT_LIST: 'EDIT_CONTACT_LIST',
  DELETE_CONTACT_LIST: 'DELETE_CONTACT_LIST',

  // Contact notes
  SET_CONTACT_NOTES_UI_FLAG: 'SET_CONTACT_NOTES_UI_FLAG',
  SET_CONTACT_NOTES: 'SET_CONTACT_NOTES',
  ADD_CONTACT_NOTE: 'ADD_CONTACT_NOTE',
  EDIT_CONTACT_NOTE: 'EDIT_CONTACT_NOTE',
  DELETE_CONTACT_NOTE: 'DELETE_CONTACT_NOTE',

  // CSAT Responses
  SET_CSAT_RESPONSE_UI_FLAG: 'SET_CSAT_RESPONSE_UI_FLAG',
  SET_CSAT_RESPONSE: 'SET_CSAT_RESPONSE',
  SET_CSAT_RESPONSE_METRICS: 'SET_CSAT_RESPONSE_METRICS',
  UPDATE_CSAT_RESPONSE: 'UPDATE_CSAT_RESPONSE',

  // Custom Attributes
  SET_CUSTOM_ATTRIBUTE_UI_FLAG: 'SET_CUSTOM_ATTRIBUTE_UI_FLAG',
  SET_CUSTOM_ATTRIBUTE: 'SET_CUSTOM_ATTRIBUTE',
  ADD_CUSTOM_ATTRIBUTE: 'ADD_CUSTOM_ATTRIBUTE',
  EDIT_CUSTOM_ATTRIBUTE: 'EDIT_CUSTOM_ATTRIBUTE',
  DELETE_CUSTOM_ATTRIBUTE: 'DELETE_CUSTOM_ATTRIBUTE',

  // Automations
  SET_AUTOMATION_UI_FLAG: 'SET_AUTOMATION_UI_FLAG',
  SET_AUTOMATIONS: 'SET_AUTOMATIONS',
  ADD_AUTOMATION: 'ADD_AUTOMATION',
  EDIT_AUTOMATION: 'EDIT_AUTOMATION',
  DELETE_AUTOMATION: 'DELETE_AUTOMATION',

  // Chatbot Flows
  SET_CHATBOT_FLOW_UI_FLAG: 'SET_CHATBOT_FLOW_UI_FLAG',
  SET_CHATBOT_FLOWS: 'SET_CHATBOT_FLOWS',
  ADD_CHATBOT_FLOW: 'ADD_CHATBOT_FLOW',
  EDIT_CHATBOT_FLOW: 'EDIT_CHATBOT_FLOW',
  DELETE_CHATBOT_FLOW: 'DELETE_CHATBOT_FLOW',

  // Custom Views
  SET_CUSTOM_VIEW_UI_FLAG: 'SET_CUSTOM_VIEW_UI_FLAG',
  SET_CUSTOM_VIEW: 'SET_CUSTOM_VIEW',
  ADD_CUSTOM_VIEW: 'ADD_CUSTOM_VIEW',
  UPDATE_CUSTOM_VIEW: 'UPDATE_CUSTOM_VIEW',
  DELETE_CUSTOM_VIEW: 'DELETE_CUSTOM_VIEW',
  SET_ACTIVE_CONVERSATION_FOLDER: 'SET_ACTIVE_CONVERSATION_FOLDER',

  // Bulk Actions
  SET_BULK_ACTIONS_FLAG: 'SET_BULK_ACTIONS_FLAG',

  // Dashboard Apps
  SET_DASHBOARD_APPS_UI_FLAG: 'SET_DASHBOARD_APPS_UI_FLAG',
  SET_DASHBOARD_APPS: 'SET_DASHBOARD_APPS',
  CREATE_DASHBOARD_APP: 'CREATE_DASHBOARD_APP',
  EDIT_DASHBOARD_APP: 'EDIT_DASHBOARD_APP',
  DELETE_DASHBOARD_APP: 'DELETE_DASHBOARD_APP',

  // Help center
  ADD_ARTICLE: 'ADD_ARTICLE',
  ADD_ARTICLE_ID: 'ADD_ARTICLE_ID',
  ADD_MANY_ARTICLES: 'ADD_MANY_ARTICLES',
  ADD_MANY_ARTICLES_ID: 'ADD_MANY_ARTICLES_ID',
  SET_ARTICLES_META: 'SET_ARTICLES_META',
  UPDATE_ARTICLE_FLAG: 'UPDATE_ARTICLE_FLAG',
  ADD_ARTICLE_FLAG: 'ADD_ARTICLE_FLAG',
  UPDATE_ARTICLE: 'UPDATE_ARTICLE',
  CLEAR_ARTICLES: 'CLEAR_ARTICLES',
  REMOVE_ARTICLE: 'REMOVE_ARTICLE',
  REMOVE_ARTICLE_ID: 'REMOVE_ARTICLE_ID',
  SET_UI_FLAG: 'SET_UI_FLAG',
  SET_ARTICLE_POSITIONS: 'SET_ARTICLE_POSITIONS',

  // Help Center -- Categories
  ADD_CATEGORY: 'ADD_CATEGORY',
  ADD_CATEGORY_ID: 'ADD_CATEGORY_ID',
  ADD_MANY_CATEGORIES: 'ADD_MANY_CATEGORIES',
  ADD_MANY_CATEGORIES_ID: 'ADD_MANY_CATEGORIES_ID',
  ADD_CATEGORY_FLAG: 'ADD_CATEGORY_FLAG',
  CLEAR_CATEGORIES: 'CLEAR_CATEGORIES',
  UPDATE_CATEGORY: 'UPDATE_CATEGORY',
  REMOVE_CATEGORY: 'REMOVE_CATEGORY',
  REMOVE_CATEGORY_ID: 'REMOVE_CATEGORY_ID',
  SET_CATEGORY_POSITIONS: 'SET_CATEGORY_POSITIONS',

  // Agent Bots
  SET_AGENT_BOT_UI_FLAG: 'SET_AGENT_BOT_UI_FLAG',
  SET_AGENT_BOTS: 'SET_AGENT_BOTS',
  ADD_AGENT_BOT: 'ADD_AGENT_BOT',
  EDIT_AGENT_BOT: 'EDIT_AGENT_BOT',
  DELETE_AGENT_BOT: 'DELETE_AGENT_BOT',
  SET_AGENT_BOT_INBOX: 'SET_AGENT_BOT_INBOX',
  UPDATE_AGENT_BOT_AVATAR: 'UPDATE_AGENT_BOT_AVATAR',

  // MACROS
  SET_MACROS_UI_FLAG: 'SET_MACROS_UI_FLAG',
  SET_MACROS: 'SET_MACROS',
  ADD_MACRO: 'ADD_MACRO',
  EDIT_MACRO: 'EDIT_MACRO',
  DELETE_MACRO: 'DELETE_MACRO',

  // Full Search
  FULL_SEARCH_SET: 'FULL_SEARCH_SET',
  CONTACT_SEARCH_SET: 'CONTACT_SEARCH_SET',
  CONTACT_SEARCH_SET_UI_FLAG: 'CONTACT_SEARCH_SET_UI_FLAG',
  CONVERSATION_SEARCH_SET: 'CONVERSATION_SEARCH_SET',
  CONVERSATION_SEARCH_SET_UI_FLAG: 'CONVERSATION_SEARCH_SET_UI_FLAG',
  MESSAGE_SEARCH_SET: 'MESSAGE_SEARCH_SET',
  ARTICLE_SEARCH_SET: 'ARTICLE_SEARCH_SET',
  CLEAR_SEARCH_RESULTS: 'CLEAR_SEARCH_RESULTS',
  MESSAGE_SEARCH_SET_UI_FLAG: 'MESSAGE_SEARCH_SET_UI_FLAG',
  ARTICLE_SEARCH_SET_UI_FLAG: 'ARTICLE_SEARCH_SET_UI_FLAG',
  FULL_SEARCH_SET_UI_FLAG: 'FULL_SEARCH_SET_UI_FLAG',
  SET_CONVERSATION_PARTICIPANTS_UI_FLAG:
    'SET_CONVERSATION_PARTICIPANTS_UI_FLAG',
  SET_CONVERSATION_PARTICIPANTS: 'SET_CONVERSATION_PARTICIPANTS',

  // Audit Logs
  SET_AUDIT_LOGS_UI_FLAG: 'SET_AUDIT_LOGS_UI_FLAG',
  SET_AUDIT_LOGS: 'SET_AUDIT_LOGS',
  SET_AUDIT_LOGS_META: 'SET_AUDIT_LOGS_META',

  // SLA
  SET_SLA_UI_FLAG: 'SET_SLA_UI_FLAG',
  SET_SLA: 'SET_SLA',
  ADD_SLA: 'ADD_SLA',
  EDIT_SLA: 'EDIT_SLA',
  DELETE_SLA: 'DELETE_SLA',

  // SLA Reports
  SET_SLA_REPORTS_UI_FLAG: 'SET_SLA_REPORTS_UI_FLAG',
  SET_SLA_REPORTS: 'SET_SLA_REPORTS',
  SET_SLA_REPORTS_METRICS: 'SET_SLA_REPORTS_METRICS',
  SET_SLA_REPORTS_META: 'SET_SLA_REPORTS_META',

  SET_TEAM_CONVERSATION_METRIC: 'SET_TEAM_CONVERSATION_METRIC',
  TOGGLE_TEAM_CONVERSATION_METRIC_LOADING:
    'TOGGLE_TEAM_CONVERSATION_METRIC_LOADING',

  // Assignment Policies
  SET_ASSIGNMENT_POLICIES_UI_FLAG: 'SET_ASSIGNMENT_POLICIES_UI_FLAG',
  SET_ASSIGNMENT_POLICIES: 'SET_ASSIGNMENT_POLICIES',
  SET_ASSIGNMENT_POLICY: 'SET_ASSIGNMENT_POLICY',
  ADD_ASSIGNMENT_POLICY: 'ADD_ASSIGNMENT_POLICY',
  EDIT_ASSIGNMENT_POLICY: 'EDIT_ASSIGNMENT_POLICY',
  DELETE_ASSIGNMENT_POLICY: 'DELETE_ASSIGNMENT_POLICY',
  SET_ASSIGNMENT_POLICIES_INBOXES: 'SET_ASSIGNMENT_POLICIES_INBOXES',
  SET_ASSIGNMENT_POLICIES_INBOXES_UI_FLAG:
    'SET_ASSIGNMENT_POLICIES_INBOXES_UI_FLAG',
  DELETE_ASSIGNMENT_POLICIES_INBOXES: 'DELETE_ASSIGNMENT_POLICIES_INBOXES',
  ADD_ASSIGNMENT_POLICIES_INBOXES: 'ADD_ASSIGNMENT_POLICIES_INBOXES',

  // Agent Capacity Policies
  SET_AGENT_CAPACITY_POLICIES_UI_FLAG: 'SET_AGENT_CAPACITY_POLICIES_UI_FLAG',
  SET_AGENT_CAPACITY_POLICIES: 'SET_AGENT_CAPACITY_POLICIES',
  SET_AGENT_CAPACITY_POLICY: 'SET_AGENT_CAPACITY_POLICY',
  ADD_AGENT_CAPACITY_POLICY: 'ADD_AGENT_CAPACITY_POLICY',
  EDIT_AGENT_CAPACITY_POLICY: 'EDIT_AGENT_CAPACITY_POLICY',
  DELETE_AGENT_CAPACITY_POLICY: 'DELETE_AGENT_CAPACITY_POLICY',
  SET_AGENT_CAPACITY_POLICIES_USERS: 'SET_AGENT_CAPACITY_POLICIES_USERS',
  SET_AGENT_CAPACITY_POLICIES_USERS_UI_FLAG:
    'SET_AGENT_CAPACITY_POLICIES_USERS_UI_FLAG',
  ADD_AGENT_CAPACITY_POLICIES_USERS: 'ADD_AGENT_CAPACITY_POLICIES_USERS',
  DELETE_AGENT_CAPACITY_POLICIES_USERS: 'DELETE_AGENT_CAPACITY_POLICIES_USERS',
  SET_AGENT_CAPACITY_POLICIES_INBOXES: 'SET_AGENT_CAPACITY_POLICIES_INBOXES',
  EDIT_AGENT_CAPACITY_POLICIES_INBOXES: 'EDIT_AGENT_CAPACITY_POLICIES_INBOXES',
  DELETE_AGENT_CAPACITY_POLICIES_INBOXES:
    'DELETE_AGENT_CAPACITY_POLICIES_INBOXES',

  // Scheduled Messages
  SET_SCHEDULED_MESSAGES_UI_FLAG: 'SET_SCHEDULED_MESSAGES_UI_FLAG',
  SET_SCHEDULED_MESSAGES: 'SET_SCHEDULED_MESSAGES',
  SET_SCHEDULED_MESSAGES_HISTORY: 'SET_SCHEDULED_MESSAGES_HISTORY',
  ADD_SCHEDULED_MESSAGE: 'ADD_SCHEDULED_MESSAGE',
  UPDATE_SCHEDULED_MESSAGE: 'UPDATE_SCHEDULED_MESSAGE',
  DELETE_SCHEDULED_MESSAGE: 'DELETE_SCHEDULED_MESSAGE',
  SET_SCHEDULED_MESSAGES_META: 'SET_SCHEDULED_MESSAGES_META',

  // Internal Chat
  SET_INTERNAL_CHAT_UI_FLAG: 'SET_INTERNAL_CHAT_UI_FLAG',
  SET_INTERNAL_CHATS: 'SET_INTERNAL_CHATS',
  ADD_INTERNAL_CHAT: 'ADD_INTERNAL_CHAT',
  UPDATE_INTERNAL_CHAT: 'UPDATE_INTERNAL_CHAT',
  DELETE_INTERNAL_CHAT: 'DELETE_INTERNAL_CHAT',
  SET_ACTIVE_INTERNAL_CHAT: 'SET_ACTIVE_INTERNAL_CHAT',
  SET_INTERNAL_CHAT_MESSAGES: 'SET_INTERNAL_CHAT_MESSAGES',
  ADD_INTERNAL_CHAT_MESSAGE: 'ADD_INTERNAL_CHAT_MESSAGE',
  DELETE_INTERNAL_CHAT_MESSAGE: 'DELETE_INTERNAL_CHAT_MESSAGE',
  UPDATE_INTERNAL_CHAT_ACTIVITY: 'UPDATE_INTERNAL_CHAT_ACTIVITY',
  MARK_INTERNAL_CHAT_AS_READ: 'MARK_INTERNAL_CHAT_AS_READ',
  INCREMENT_INTERNAL_CHAT_UNREAD: 'INCREMENT_INTERNAL_CHAT_UNREAD',
  UPDATE_INTERNAL_CHAT_UNREAD_COUNT: 'UPDATE_INTERNAL_CHAT_UNREAD_COUNT',
};
